import { get, head } from "lodash";

const parseActiveExperts = agentGqlData => {
  const { data, ...gqlReqInfo } = agentGqlData;
  const listing = get(data, "sale");
  const building = get(data, "building", get(listing, "building"));
  const expertData = get(
    data,
    "experts_program.campaign.active_experts_data",
    []
  );

  // only return one expert even if the api returns more than one
  const expert = head(expertData);

  return {
    data,
    ...gqlReqInfo,
    building,
    expert,
    listing
  };
};

export default parseActiveExperts;
